import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../../Services/AuthContext';

// type Props = {
//   isAdmin: boolean;
// };

const MagasinHeader = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // const goToAdmin = () => {
  //   navigate('/admin');
  // };

  const goToSite = () => {
    navigate('/tableau/list');
  };
  return (
    <nav className="navbar navbar-expand-lg  navbar-dark bg-dark shadow-sm">
      <div className="container-fluid">
        <NavLink to="/" className="navbar-brand fw-bold">
          Magasin
        </NavLink>

        <div className="d-flex align-items-center gap-3">


        <button onClick={goToSite} className="btn btn-sm btn-outline-primary">
            voir le site
        </button>

          {user ? (
            <>
              <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
                Déconnexion
              </button>
            </>
          ) : (
            <NavLink to="/login" className="btn btn-outline-primary btn-sm">
              Connexion
            </NavLink>
          )}

          {/* {isAdmin && (
            <button onClick={goToAdmin} className="btn btn-sm btn-outline-primary">
              Espace Admin
            </button>
          )} */}

         
        </div>
      </div>
    </nav>
  );
};

export default MagasinHeader;
